import React from 'react'

import {
  TableContainer,
  TableRow,
  TableBody,
  TableCell,
  Table,
  Paper
} from '@mui/material'

import { PickingRouteReviewError } from './PickingRouteReviewError'

import { PickingRouteProductDetail } from '../../../../interfaces/PickingRoute/PickingRouteDetails/PickingRouteProductDetail'
import { eTypePickingRoute } from '../../../../enums/eTypePickingRoute'

interface PickingRouteReviewTableProps {
  error: string | undefined
  productDetails: PickingRouteProductDetail[]
  ot: number
  typePickingRouteId?: number
}

export const PickingRouteReviewTable: React.FC<
  PickingRouteReviewTableProps
> = ({ productDetails, error, ot, typePickingRouteId }) => {
  const productQty = productDetails
    .map((pd) => pd.qty)
    .reduce((prev, curr) => prev + curr, 0)

  const skuQty = productDetails.length

  return (
    <TableContainer component={Paper}>
      <Table size='small'>
        {error !== undefined && <PickingRouteReviewError error={error} />}
        {error === undefined && (
          <TableBody>
            <TableRow key='ean'>
              <TableCell component='th' scope='row'>
                SKU
              </TableCell>
              <TableCell align='right'>{skuQty}</TableCell>
            </TableRow>
            <TableRow key='ot'>
              <TableCell component='th' scope='row'>
                OT
              </TableCell>
              <TableCell align='right'>
                {typePickingRouteId === eTypePickingRoute.RTV ? `RTV${ot}` : ot}
              </TableCell>
            </TableRow>
            <TableRow key='qty'>
              <TableCell component='th' scope='row'>
                Cantidad Productos
              </TableCell>
              <TableCell align='right'>{productQty}</TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
    </TableContainer>
  )
}
